import { render, staticRenderFns } from "./ParentCategory.vue?vue&type=template&id=3d06d3c6&"
import script from "./ParentCategory.vue?vue&type=script&lang=js&"
export * from "./ParentCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports